export enum ResourcesAccess {
  OWNER_ADMIN = "OWNER_ADMIN",
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  GATINGSYSTEM = "GatingSystem",
}
